import React, { useState, useRef, useEffect } from 'react';
import clsx from 'clsx';
// import moreBtnImage from 'images/sports/common/more-btn.png';
// import moreCloseBtnImage from 'images/sports/common/more-close-btn.png';
// import BaseballMatchGamePeriodScore from 'routes/score/baseball/match/game/periodScore';
import { Date, PeriodScore, Location, Odds } from '../styled';
import BaseballMatchRecordBoxScore from '../../boxScore/boxScore';

const BaseballMatchRecordTableItem = ({ item }) => {
  const boxScoreRef = useRef();
  const moreButtonRef = useRef();
  const [isOpen, setOpen] = useState(false);
  const { teamsData, oddsData } = item;

  const onClickMore = () => {
    setOpen(!isOpen);
  };

  useEffect(() => {
    document.addEventListener('click', onClick, true);
    return () => {
      document.removeEventListener('click', onClick, true);
    };
  }, []);

  const onClick = (event) => {
    if (boxScoreRef.current && !boxScoreRef.current.contains(event.target)) {
      if (
        moreButtonRef.current &&
        !moreButtonRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    }
  };

  return (
    <li onClick={onClickMore}>
      <div className="game">
        <Date>{item.date}</Date>
        <Location>
          <div className={clsx('team', 'home')}>
            <span>{teamsData.home.name}</span>
            <span>{teamsData.home.pitcher}</span>
          </div>
          <div className="score">
            <p className={clsx(teamsData.home.winner && 'on')}>
              {teamsData.home.score}
            </p>
            <span className={'scoreCenter'}>:</span>
            <p className={clsx(teamsData.away.winner && 'on')}>
              {teamsData.away.score}
            </p>
          </div>
          <div className={clsx('team', 'away')}>
            <span>{teamsData.away.name}</span>
            <span>{teamsData.away.pitcher}</span>
          </div>
        </Location>
        <Odds>
          <span
            className={clsx(
              'oddsItem',
              oddsData.winLose.home.hit ? 'home' : 'away'
            )}
          >
            {oddsData.winLose.home.hit ? '홈승' : '홈패'}
          </span>
          <span
            className={clsx(
              'oddsItem',
              oddsData.handicap.home.hit ? 'home' : 'away'
            )}
          >
            {oddsData.handicap.home.hit ? '핸디승' : '핸디패'}
          </span>
          <span
            className={clsx(
              'oddsItem',
              oddsData.unover.home.hit ? 'away' : 'home'
            )}
          >
            {oddsData.unover.home.hit ? '언더' : '오버'}
          </span>
        </Odds>
      </div>
      {isOpen && <BaseballMatchRecordBoxScore item={item} />}
    </li>
  );
};

export default BaseballMatchRecordTableItem;
